import './main';

const mobileElement = document.querySelector('.careers-single__form.mobile');
const desktopElement = document.querySelector('.careers-single__form.desktop');

if (window.innerWidth < 1024) {
    desktopElement.remove();
} else {
    mobileElement.remove();
}

function goToForm() {
    const Form = document.querySelector('.careers-form')
    const itemPosition = Form.offsetTop - 100
    window.scrollTo({top: itemPosition, behavior: 'smooth'})
}

function handleScroll(event) {
    const Form = document.querySelector('.careers-single--go-to')
    if (window.scrollY <= this.footerTop) {
        Form.classList.add('go-to-fixed')
    } else {
        Form.classList.remove('go-to-fixed')
    }
}

function SetFooterTop() {
    const Footer = document.querySelector('.footer')
    this.footerTop = Footer.offsetTop - Footer.offsetHeight
}

window.onload = SetFooterTop

window.addEventListener('scroll', handleScroll)

const button = document.querySelector('.careers-single--go-to');

button.addEventListener('click', goToForm)

document.addEventListener('DOMContentLoaded', function () {
    const inputElement = document.querySelector('.careers-btn input[type="submit"]');
    const careersBtnElement = document.querySelector('.careers-btn');

    function updateButtonClass() {
        if (inputElement.disabled) {
            careersBtnElement.classList.add('disabled');
        } else {
            careersBtnElement.classList.remove('disabled');
        }
    }

    updateButtonClass();

    const observer = new MutationObserver(updateButtonClass);
    observer.observe(inputElement, {attributes: true, attributeFilter: ['disabled']});
});

const fileInput = document.querySelector('.file-upload-input');
const uploadButton = document.querySelector('.file-upload-button');
const uploadDetails = document.querySelector('.file-upload-details');
const fileNameSpan = document.querySelector('.file-name');
const removeFileSpan = document.querySelector('.remove-file');

fileInput.addEventListener('change', function () {
    if (fileInput.files.length > 0) {
        fileNameSpan.textContent = fileInput.files[0].name;
        uploadButton.style.display = 'none';
        uploadDetails.style.display = 'flex';
    }
});

removeFileSpan.addEventListener('click', function () {
    fileInput.value = '';
    uploadButton.style.display = 'flex';
    uploadDetails.style.display = 'none';
});


const jobTitle = document.querySelector('.careers-single-title').innerHTML;
const hiddenFieldPostion = document.querySelector('input[name="position"]');
if (hiddenFieldPostion) {
    hiddenFieldPostion.value = jobTitle;
}

const jobUrl = document.location.href || '';
const hiddenFieldUrl = document.querySelector('input[name="career-url"]');
if (hiddenFieldUrl) {
    hiddenFieldUrl.value = jobUrl;
}

const hiddenFieldAction = document.querySelector('input[name="action-id"]');
if (hiddenFieldAction) {
    hiddenFieldAction.value = Math.random().toString(36).slice(2, 10).padStart(8, '0');
}
